// src/components/StatsBar.js
import React from "react";

export function StatsBar({ total, loading }) {
  return (
    <div className="stats-bar">
      <span className="stats-label">PROGRAMS LOADED</span>
      <span className={`stats-count ${loading ? "stats-count--loading" : ""}`}>
        {loading ? "…" : total}
      </span>
    </div>
  );
}
